import React, {useCallback} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {countriesConstants, DistrictDropdown, SetSchoolAction} from "mindsets-js-sdk";

function DistrictField({setUpdated}) {
    const dispatch = useDispatch();
    const school = useSelector(state => state.school);

    const debounce = useCallback(_.debounce(a => a(), 600), []);

    function onSelect(district) {
        let school_new = JSON.parse(JSON.stringify(school));
        if (district) {
            school_new.district = district;
            school_new.district_id = district.id;
            if (district.country) {
                school_new.country = district.country;
            }
            if (district.state) {
                school_new.state = district.state;
            }
            if (district.city) {
                school_new.city = district.city;
            }
        } else {
            delete school_new.district;
            school_new.district_id = null;
        }
        dispatch(SetSchoolAction(school_new));
        setUpdated(true);
    }

    if (!school.country || -1 === countriesConstants.COUNTRIES_WITH_DISTRICTS.indexOf(school.country)) {
        return null;
    }

    return (
        <div className="row">
            <label htmlFor="autoload-field" className="col-sm-3 col-form-label">District Name</label>
            <div className="col-sm-9">
                <DistrictDropdown
                    onSelect={district => {
                        onSelect(district);

                        return district ? district.name : '';
                    }}
                    placeholder='District Name'
                    input_class='form-control'
                    country={school.country}
                    state={school.state}
                    city={school.city}
                    default_value={school.district ? school.district.name : null}
                    id='scholol-update-district'
                    show_counts={true}
                    debounce={debounce}
                    onReset={() => {
                        let school_new = JSON.parse(JSON.stringify(school));
                        delete school_new.district;
                        school_new.district_id = null;
                        dispatch(SetSchoolAction(school_new));
                        setUpdated(true);
                    }}
                />
            </div>
        </div>
    );
}

DistrictField.propTypes = {
    setUpdated: PropTypes.func.isRequired
}

export default DistrictField;
